import Trans from 'next-translate/Trans'

export const SingleOfferTimer = ({ hours, minutes, seconds, completed }) => {
  if (completed) {
    // Render a completed state
    return <span><Trans i18nKey="offer:timeIsUp" /></span>
  }
  // Render a countdown
  return (
    <>
      {' '}
      <div className="text-12">
        <Trans i18nKey="offer:youHave" />
        {' '}
        {' '}

        <span style={{ fontSize: 17 }}>
          {(`${hours}`).padStart(2, '0')}
          :
          {(`${minutes}`).padStart(2, '0')}
          :
          {(`${seconds}`).padStart(2, '0')}
        </span>
        {' '}
        {' '}
        <Trans i18nKey="offer:minutesLeft" />
      </div>
    </>

  )
}
